'use client'

import React from 'react'
import Link from 'next/link'

type Props = {
  mobileMenuOpen: boolean
  navItems: { path: string; label: string }[]
  isActive: (path: string) => boolean
  onClose: () => void
  pendingMoyensCount: number
}

export default function MobileNav({ mobileMenuOpen, navItems, isActive, onClose, pendingMoyensCount }: Props) {
  return (
    <div className={`md:hidden ${mobileMenuOpen ? 'block' : 'hidden'} border-t border-gray-200 bg-white`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 space-y-1">
        {navItems.map((item) => (
          <Link key={item.path} href={item.path} passHref>
            <span
              onClick={onClose}
              className={`block px-2 py-2 text-sm rounded-md cursor-pointer ${
                isActive(item.path)
                  ? 'text-blue-700 bg-blue-50 font-medium'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <span className="inline-flex items-center">
                {item.label}
                {item.label === 'Création' && pendingMoyensCount > 0 && (
                  <span className="ml-2 inline-flex items-center justify-center bg-orange-500 text-white text-[10px] leading-none px-1.5 py-0.5 rounded-full">
                    {pendingMoyensCount}
                  </span>
                )}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  )
}
